import React from 'react';

const Wager = ({wager, onChange}) => {
    return (
        <div>
            <input
              type='text'
              value={wager}
              onChange={onChange}
             />
        </div>
    )
}

export default Wager;


// WEBPACK FOOTER //
// ./src/components/bet/Wager.js